/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import FalconCloseButton from 'components/common/FalconCloseButton';
import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormControl, InputGroup, Modal, Row } from 'react-bootstrap';
import { sdCreateIssue, sdGetMe, sdGetProject } from 'services/service-desk/sdService';
import SDStatusSelect from './SDStatusSelect';
import { sdGetSelectedProjectId, sdShowToast } from 'helpers/sdHelper';
import SDPrioritySelect from './SDPrioritySelect';
import SDCategorySelect from './SDCategorySelect';
import SDUserSelect from './SDUserSelect';
import SDCreatableUserSelect from './SDCreateableUserSelect';
import SDEditor from './SDEditor';

const SDCreateIssueModal = ({ show, handleClose, projects, selectedProjectId }) => {
    const [project, setProject] = useState(false);
    const [me, setMe] = useState(null);
    const [updateIssueData, setUpdateIssueData] = useState(null);
    const [description, setDescription] = useState('');

    useEffect(() => {
        sdGetMe().then(res => {
            setMe(res.data);
        }).catch(err => {
            console.error(err);
        })
    }, []);

    useEffect(() => {
        if (show) {
            let pid = sdGetSelectedProjectId();
            sdGetProject(pid).then(res => {
                setProject(res.data);
            }).then(err => {
                console.log(err);
            })
        }
    }, [show]);

    useEffect(() => {
        console.log("Create issue modal project", project);
    }, [project]);

    useEffect(() => {
        if (!project) return;
        let initialStatusId = project.defaultStatusId ? project.defaultStatusId : project.statuses[0].id;
        let initialPriorityId = project.defaultPriorityId ? project.defaultPriorityId : project.priorities[0].id;
        let initalReportedByUserId = me ? me.id : 0;
        console.log("Initial priority id = ", initialPriorityId);
        setUpdateIssueData({
            ...updateIssueData,
            projectId: project.id,
            statusId: initialStatusId,
            priorityId: initialPriorityId,
            categoryId: 0,
            reportedByUserId: initalReportedByUserId
        });
    }, [project]);

    const onCreateClick = () => {
        sdCreateIssue(updateIssueData).then(res => {
            let id = res.data.id;
            window.open("/service-desk/issue/" + id);
            handleClose();
        }).catch(err => {
            console.log(err);
            sdShowToast("Failed to create issue.", true);
        })
    }

    if (!updateIssueData) {
        return <></>
    }

    return (<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
        <Modal.Header>
            <Modal.Title>Create Issue</Modal.Title>
            <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
            {/* Project - not editable */}
            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">Project</InputGroup.Text>
                <FormControl
                    placeholder={project.name}
                    aria-label={project.name}
                    aria-describedby="basic-addon1"
                    disabled
                />
            </InputGroup>

            <Row className="g-3">
                {/* Issue Status */}
                {project.statuses ?
                    <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Status</Form.Label>
                        <SDStatusSelect initialValue={updateIssueData.statusId} statuses={project.statuses} onUpdate={(val) => { setUpdateIssueData({ ...updateIssueData, statusId: val }) }}></SDStatusSelect>
                    </Form.Group> : <></>}

                {/* Issue Priority */}
                {project.priorities ?
                    <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Priority</Form.Label>
                        <SDPrioritySelect initialValue={updateIssueData.priorityId} priorities={project.priorities} onUpdate={(val) => { setUpdateIssueData({ ...updateIssueData, priorityId: val }) }}></SDPrioritySelect>
                    </Form.Group> : <></>}

                {/* Issue Category */}
                {project.categories ?
                    <Form.Group as={Col} className="mb-0" controlId="exampleForm.ControlInput1">
                        <Form.Label>Category</Form.Label>
                        <SDCategorySelect categories={project.categories} onUpdate={(val) => { setUpdateIssueData({ ...updateIssueData, categoryId: val }) }}></SDCategorySelect>
                    </Form.Group> : <></>}
            </Row>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Subject</Form.Label>
                <Form.Control type="text" placeholder="Enter subject" onChange={(e) => { setUpdateIssueData({ ...updateIssueData, subject: e.target.value }) }} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label>Description</Form.Label>
                <SDEditor value={description} onChange={(val) => { setDescription(val); setUpdateIssueData({ ...updateIssueData, description: val }) }}></SDEditor>
            </Form.Group>

            {project.users ?
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Reported By</Form.Label>
                    <SDCreatableUserSelect users={project.users} initialValue={updateIssueData.reportedByUserId}  onUpdate={(val) => { setUpdateIssueData({ ...updateIssueData, reportedByUserId: val }) }}></SDCreatableUserSelect>
                </Form.Group>
                : <></>}

            {project.users ?
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Assigned To </Form.Label>
                    <SDUserSelect users={project.users} onUpdate={(val) => { setUpdateIssueData({ ...updateIssueData, assignedToUserId: val }) }}></SDUserSelect>
                </Form.Group>
                : <></>}

        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            <Button variant="primary" onClick={onCreateClick}>Create</Button>
        </Modal.Footer>
    </Modal>)
}

export default SDCreateIssueModal;